import UserActionTypes from "./user.types"


const INITIAL_STATE = {
  user: null,
  cloudUser: null,
}

const userReducer = (state=INITIAL_STATE, action) => {
  switch(action.type) {
    case UserActionTypes.FETCH_USER_SUCCESS:
      return {
        ...state,
        user: action.payload
      }
      case UserActionTypes.FETCH_USER_INFO_SUCCESS:
        return {
          ...state,
          user: action.payload.user,
          cloudUser: action.payload.cloudUser
        }
    default:
      return state
  }
}

export default userReducer

